<li ngbDropdown class="nav-item dropdown-notification mr-25">
  <a class="nav-link" ngbDropdownToggle id="navbarNotificationDropdown"
    ><i class="ficon" data-feather="bell"></i
    ><span class="badge badge-pill badge-danger badge-up">6</span></a
  >
  <ul
    ngbDropdownMenu
    aria-labelledby="navbarNotificationDropdown"
    class="dropdown-menu dropdown-menu-media dropdown-menu-right"
  >
    <!-- Notifications header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 me-auto">Notifiche</h4>
        <div class="badge badge-pill badge-light-primary">
          6 Nuove
        </div>
      </div>
    </li>
    <!--/ Notifications header -->

    <!-- Notifications content -->
    <li class="scrollable-container media-list p-2">

      <a href="javascript:void(0)" class="d-flex ng-star-inserted mb-2">
        <div class="media d-flex align-items-start">
          <div class="media-body"><div class="media-heading"><span class="font-weight-bolder">
              Rinnovo Programma</span></div><small class="notification-text">
          Il programma 1020/217 è stata rinnovata
        </small>
        </div>
        </div>
      </a>

      <a href="javascript:void(0)" class="d-flex ng-star-inserted mb-2"><div class="media d-flex align-items-start">
        <div class="media-body"><div class="media-heading"><span class="font-weight-bolder">Nuovo Mssaggio</span></div><small class="notification-text">Hai un nuovo Messaggio non letto</small></div></div></a>
      <a href="javascript:void(0)" class="d-flex ng-star-inserted mb-2"><div class="media d-flex align-items-start">
        <div class="media-body"><div class="media-heading"><span class="font-weight-bolder">Richiesta Documenti</span></div><small class="notification-text">Verifica la Documentazione dal tuo Profilo</small></div></div></a>


    </li>
    <!--/ Notifications content -->

    <!-- Notifications footer -->
    <li class="dropdown-menu-footer">
      <a class="btn btn-primary d-block w-100 waves-effect waves-light" href="javascript:void(0)">Leggi tutte le Notifiche</a>
    </li>
    <!--/ Notifications footer -->
  </ul>
</li>
